import { render, staticRenderFns } from "./WidgetCollapseLayout.vue?vue&type=template&id=44541898&scoped=true&"
import script from "./WidgetCollapseLayout.vue?vue&type=script&lang=js&"
export * from "./WidgetCollapseLayout.vue?vue&type=script&lang=js&"
import style0 from "./WidgetCollapseLayout.vue?vue&type=style&index=0&id=44541898&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44541898",
  null
  
)

export default component.exports